module.exports = __webpack_public_path__ + "img/logo.afb1f06a.jpg";